<template>
  <div style="padding: 10px">
    <el-table
      :data="state.tableData"
      v-loading="!Array.isArray(state.tableData)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <el-table-column
        fixed
        label="序号"
        width="50"
        type="index"
        align="center"
      />
      <el-table-column
        prop="create_time"
        label="上传时间"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="attachment_name"
        label="档案附件名称"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="file_ext"
        label="附件类型"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        label="操作"
        width="220"
        align="center"
        fixed="right"
        className="tabBtn"
      >
        <template #default="{ row }">
          <el-button type="primary" link icon="Search" @click="onSearch(row)">
            查看
          </el-button>
          <el-button type="danger" link icon="Delete" @click="onDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_info, employee_attachment_delete } from "@/http/employee";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      if (props.employee_id) {
        onLoad();
      }
    });

    const onLoad = () => {
      delete state.tableData;

      employee_info(props.employee_id).then((res) => {
        if (res.status == 200) {
          state.tableData = res.data.data?.attachment || [];
        }
      });
    };

    //删除
    const onDelete = (row) => {
      ElMessageBox.confirm("您确定删除该员工档案吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      }).then(() => {
        const data = {
          employee_id: props.employee_id,
          attachment_field: row.attachment_field,
          attachment_id: row.id,
        };
        employee_attachment_delete(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onSearch = (row) => {
      window.open(row.file_url, "_blank");
    };

    return { state, onSearch, onDelete };
  },
};
</script>
<style scoped></style>
